import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { DualColRow } from 'src/components/common/DualColRow/DualColRow'
import { DisbursementTriggerEnum, DisbursementTriggerLabel } from 'src/services/Enum/DisbursementTriggerEnum'
import { ITrade } from 'src/services/interfaces/trade/ITrade'
import { formatCurrency } from 'src/util/Masks/formatCurrency'

interface IPriceInfoProps {
  trade?: ITrade
}

export const PriceInfo: React.FC<IPriceInfoProps> = ({ trade: { phase, tradePricing: { pricing } } }) => {
  return (<>
    <DualColRow title="Preço:" />
    {pricing?.pricingDisbursements?.sort((item1, item2) => Number(item1.trigger === DisbursementTriggerEnum.P1 ? -1 : item2.trigger === DisbursementTriggerEnum.P1 ? 1 : 0)).map(({ alreadyPaid, trigger, price }) => (

      <div className="row">
        <span className="left description">
          <FontAwesomeIcon
            className={`price-info-icon ${alreadyPaid ? 'green' : 'red'}`}
            icon={alreadyPaid ? faCheck : faTimes}
          />
          {alreadyPaid ? 'Pago' : 'A pagar'} em {DisbursementTriggerLabel.get(trigger)}:
        </span>
        <span className="right description">{formatCurrency(price)}</span>
      </div>
    ))}
  </>)
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/TradeList/Components/PricingInfo/PriceInfo.tsx